import Modal from 'react-bootstrap/Modal';
import TitleTooltip from "../../../components/helpers/TitleTooltip";
import { useState, useRef, } from "react"; //useMemo
import { DatePicker, CustomProvider } from "rsuite";
import * as locales from 'rsuite/locales';
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import {axiosInstance} from "../../../components/helpers/axiosInstance";
import { useToast } from "../../../components/notificaciones/ToastProvider";
import { useContratos } from "../../../components/contratos/ContratosProvider";
/**
 * COMPONENTE PRINCIPAL
 * @param contrato (información de contrato)
 * @returns {JSX.Element}
 * @constructor
 */
export default function PromesaPago({
    contrato,
}) {
    /**
     * IsBetween indica si una fecha esta entre otra dos fechas
     */
    dayjs.extend(isBetween);
    /**
     * Fecha actual
     * @type {Date}
     */
    const today = new Date();
    /**
     * Abrir/cerrar modal
     */
    const [show, setShow] = useState(false);
    /**
     * Renderizar DatePicker en modal
     * @type {React.MutableRefObject<null>}
     */
    const containerRef = useRef(null);
    /**
     * Guardar fecha de promesa de pago
     */
    const [promesa, setPromesa] = useState(today);
    /**
     * Cálcular fecha de corte
     * @type {string}
     */
    //const corte = useMemo(() => {

        // const a = dayjs().format('YYYY-MM');
        // const today = dayjs(a).format('DD');

        //return dayjs().add(15, "days").format('YYYY-MM-DD');

        // if (contrato.corte === 30 && today <= 15){
        //     return dayjs(a + '-' + contrato.corte).add(16, 'days').add(-1, 'month').format('YYYY-MM-DD');
        // } else  {
        //     return dayjs(a + '-' + contrato.corte).add(16, 'days').format('YYYY-MM-DD');
        // }

        // const month = dayjs().get('month');
        // const year = dayjs().get('year');
        //
        //
        // if (contrato.corte === 30){
        //     return dayjs().set('year', year).set('month', month).set('day', 14).format('YYYY-MM-DD');
        // } else {
        //     return dayjs(year + '-' + Number(month+1) + '31').format('YYYY-MM-DD');
        // }
    //},[contrato.corte])
    //dayjs().subtract(1, "day").format('YYYY-MM-DD')
    /**
     * @var begin día actual
     * @type {dayjs.Dayjs}
     */
    const begin = dayjs().subtract(1, 'day');
    /**
     * @var cut 3 días habiles de la fecha actual
     * @type {dayjs.Dayjs}
     */
    const cut= () => {
        let date = dayjs();
        let added = 0;
        while (added < 3) {
            date = date.add(1, 'day');
            if (date.day() !== 0 && date.day() !== 6) {
                added++;
            }
        }
        return date;
    }

    /**
     * Menejo de notíficaciones
     * @type {undefined}
     * @property setArrayToast
     */
    const toast = useToast();
    /**
     * Usar función handleChangeState
     * @function handleChangeState Cambiar datos en Storage y actualizar array de contratos
     */
    const { handleChangeState } = useContratos();
    /**
     * @function handleCLose Reiniciar valores
     */
    function handleCLose() {
        setShow(false);
        setPromesa(today);
    }
    /**
     * @function handleSend Enviar fecha a servidor
     */
    function handleSend(){
        axiosInstance.post('/clientes/' + contrato.id_cliente +'/contratos/'+contrato.id_contrato+'/pagos/promesa', {
            fecha_de_pago : dayjs(promesa).format('YYYY-MM-DD'),
        }).then((response) => {
            if (response.status === 200) {
                /**
                 * Notificación : exitosa
                 */
                toast.setArrayToast(
                    prevToasts => [
                        ...prevToasts,
                        {
                            id : contrato.id_contrato,
                            text: "Promesa de pago registrado",
                            color: 'success',
                            show: true
                        }
                    ]
                );
                /**
                 * Cambiar los nuevos datos del contratos
                 */
                const last = contrato.ultimo_pago.fecha_pago ?? [];
                handleChangeState( contrato.id_contrato, response.data[0].vigente, last, response.data[0].hasta, 0 );
                handleCLose();
            }
        }).catch((error) => {
            /**
             * Notificación : no se guardo la fecha
             */
            toast.setArrayToast(
                prevToasts => [
                    ...prevToasts,
                    {
                        id : contrato.id_contrato,
                        text: "Hubo un error en los datos: " + error.response.data.errors[0].details,
                        color: 'danger',
                        show: true
                    }
                ]
            );
        });
    }


    return (
        <>
            <style type={'text/css'}>
                {`
                    .rs-input{
                        text-transform : capitalize!important;
                    }
                    
                    .rs-calendar-header-title{
                        text-transform : capitalize!important;
                    }
                    .promesa > div{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #promesa{
                        padding-top: 1.75rem!important;
                        display: block!important;
                        background-color: transparent!important;
                        text-transform: uppercase!important;
                    }
                    
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                `}
            </style>
            <TitleTooltip title={'Promesa de pago'} placement={'bottom'}>
                <button className={"btn btn-sm btn-icon btn-active-light btn-active-icon-primary "} onClick={() => setShow(true)}>
                    <i className="bi bi-hourglass-split fs-2"></i>
                </button>
            </TitleTooltip>
            <Modal
                show={show}
                onHide={handleCLose}
                keyboard={false}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <div className="d-flex justify-content-center align-items-center">
                        <i className="bi bi-calendar2-range fs-2qx text-primary"></i>
                        {/*<div className={'d-block'}>*/}
                            <span className="modal-title h3 ps-2"> Activar usuario con pago posterior </span>
                            {/*<div className={'text-muted fs-7 ps-2'}>Hasta quince días después de su fecha de corte</div>*/}
                        {/*</div>*/}
                    </div>
                </Modal.Header>
                <Modal.Body className={'d-flex justify-content-center align-items-center'}>
                    <div ref={containerRef} className={'position-relative'}>
                        <CustomProvider locale={locales.esES}>
                            <DatePicker
                                container={() => containerRef.current}
                                className={'promesa'}
                                label={<div className={'labelSelect ps-3 pb-4'}>Fecha de pago</div>}
                                oneTap
                                style={{ width: "100%" }}
                                menuStyle={{width : "100%"}}
                                id={'promesa'}
                                name={'promesa'}
                                cleanable={false}
                                format={'MMM dd, yyyy'}
                                value={promesa}
                                onChange={setPromesa}
                                shouldDisableDate={date => {
                                    return date.getDay() === 0 || date.getDay() === 6 || !dayjs(date).isBetween(begin, cut(), 'day')

                                }}
                            />
                        </CustomProvider>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type={'button'} className={"btn btn-secondary me-5"} onClick={handleCLose}>Cancelar</button>
                    <button type={'button'} className={"btn btn-primary me-3"} onClick={handleSend}>Enviar</button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
